import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { Add as AddIcon } from "@mui/icons-material";
import { DocumentItemCard } from "./DocumentItemCard";

type Props = {
  elem: any;
  isXsOrSm: boolean;
  partnerStartedJourney: boolean;
  hideAddButton?: boolean;
  hideUploadButton?: boolean;
  hideAccountAggregator?: boolean;
  uploadDocumentLoader: any[];
  digiLockerLoaderId: any[];
  viewDocumentLoader: any[];
  uploadedVia: any;
  onShowAddMoreDocument: (categoryId: number) => void;
  onUploadDocument: (docId: any, item: any) => void;
  onViewDocument: (item: any, index?: number) => void;
  onOpenAccountAggregatorModal: () => void;
  onCreateFIData?: (item: any) => void;
  onGetFIData?: (item: any) => void;
  showFIButtons?: boolean;
  showGetFIButton?: boolean;
};

export function DocumentCategoryCard({
  elem,
  isXsOrSm,
  partnerStartedJourney,
  hideAddButton = false,
  hideUploadButton = false,
  hideAccountAggregator = false,
  uploadDocumentLoader,
  digiLockerLoaderId,
  viewDocumentLoader,
  uploadedVia,
  onShowAddMoreDocument,
  onUploadDocument,
  onViewDocument,
  onOpenAccountAggregatorModal,
  onCreateFIData,
  onGetFIData,
  showFIButtons,
  showGetFIButton,
}: Props) {
  return (
    <Box sx={{ mb: 4 }}>
      <Box
        sx={{
          borderRadius: "8px",
          border: "1px solid #e0e0e0",
          backgroundColor: "#fff",
          p: 0,
        }}
      >
        <Box
          sx={{
            backgroundColor: "rgba(0, 179, 181, 0.08)",
            padding: "12px 16px",
            borderRadius: "8px 8px 0 0",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              fontSize: "16px",
              color: "#1F2233",
            }}
          >
            {elem?.name}
          </Typography>
          {!partnerStartedJourney && !hideAddButton && (
            <Button
              variant="outlined"
              startIcon={<AddIcon />}
              sx={{
                borderColor: "#00b3b5",
                color: "#00b3b5",
                textTransform: "none",
                fontSize: "14px",
                fontWeight: 500,
                px: 2,
                py: 0.5,
                borderRadius: "6px",
                backgroundColor: "rgba(0, 179, 181, 0.08)",
                "&:hover": {
                  borderColor: "#00999a",
                  backgroundColor: "rgba(0, 179, 181, 0.08)",
                },
              }}
              onClick={() => onShowAddMoreDocument(elem?.id)}
            >
              Add
            </Button>
          )}

        </Box>

        {elem?.documents?.length <= 0 && (
          <Box
            sx={{
              p: 2,
              display: "flex",
              flexDirection: "column",
              gap: 2,
            }}
          >
            <Typography>
              Please upload the {elem?.name} as applicable
            </Typography>
          </Box>
        )}

        {elem?.documents?.map((item: any) => (
          <Box
            key={item?.id ?? item?.docName}
            sx={{
              p: 2,
              display: "flex",
              flexDirection: "column",
              gap: 2,
            }}
          >
            <DocumentItemCard
              item={item}
              isXsOrSm={isXsOrSm}
              partnerStartedJourney={partnerStartedJourney}
              hideUploadButton={hideUploadButton}
              hideAccountAggregator={hideAccountAggregator}
              uploadDocumentLoader={uploadDocumentLoader}
              digiLockerLoaderId={digiLockerLoaderId}
              viewDocumentLoader={viewDocumentLoader}
              uploadedVia={uploadedVia}
              onUploadDocument={onUploadDocument}
              onViewDocument={onViewDocument}
              onOpenAccountAggregatorModal={onOpenAccountAggregatorModal}
              onCreateFIData={onCreateFIData}
              onGetFIData={onGetFIData}
              showFIButtons={showFIButtons}
              showGetFIButton={showGetFIButton}
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
}

